import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Camera } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

export const PhotographyNote = () => (
  <section data-testid="photography-note" className="w-full mx-auto px-4 sm:px-8 md:px-12 py-24 md:py-32 border-t border-[#D4D7DD]">
    <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
      <div className="md:col-span-7">
        <p className="label text-[#2B6BFF] mb-6 flex items-center gap-2"><Camera className="w-4 h-4" /> The Lookbook</p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
          className="font-serif-display text-5xl sm:text-7xl leading-[0.88]">
          Every piece,<br /><span className="volt">its own story.</span>
        </motion.h2>
      </div>
      <div className="md:col-span-5 md:pt-4">
        <p className="text-lg md:text-xl leading-relaxed text-[#3A4150]">
          Each drop is photographed individually — real garments, shot clean and close so you see the fabric, the fit and the detail before you buy.
        </p>
        <p className="mt-5 text-base leading-relaxed text-[#6A7180]">
          New pieces are added and photographed as they release, each with its own front, back and detail shots. What you see is exactly what shows up at your door.
        </p>
        <Link to="/shop" data-testid="photography-cta"
          className="mt-8 inline-flex bg-[#0B0E14] text-[#EDEEF1] px-8 h-14 items-center label hover:bg-[#1B2233] transition-colors duration-300">
          Browse the Collection →
        </Link>
      </div>
    </div>
  </section>
);
